var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { NotifyActionTypes } from "./notify.actions";
export var initialNotifyState = {
    error: {
        code: null,
        message: null
    }
};
export function notifyReducer(state, action) {
    if (state === void 0) { state = initialNotifyState; }
    switch (action.type) {
        case NotifyActionTypes.ShowError:
            return __assign({}, state, { error: {
                    code: action.payload.code,
                    message: action.payload.message
                } });
        default:
            return state;
    }
}
